import { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useStateMachine } from "little-state-machine";
import { useParams } from "react-router-dom";

import "./ShipmentQuotesV2.scss";
import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";
import QuotationDetailDrawer from "pages/common/ShipmentQuotesV2/components/QuotationDetailDrawer/QuotationDetailDrawer";
import CustomLongfield from "pages/common/ShipmentQuotesV2/components/CustomLongfield";
import QuotesTable from "./components/QuotesTable";
import QuotationHeader from "../QuotationDetail/QuotationHeader";
import { IShipmentData } from "../QuotationDetail/QuotationType";
import Comments from "./components/Comments";

interface IQuotationViewProps {
  isQuickRequest: boolean;
  fetchShipment: any;
  shipmentData: IShipmentData;
  shipmentBasicError: any;
}

const ShipmentQuotesV2 = function (props: IQuotationViewProps) {
  const id: any = useParams()?.id?.toUpperCase();
  const { fetchShipment } = props;

  const { state }: any = useStateMachine({ updateShipment, updateRequest });
  const methods = useForm();

  const {
    data,
    isInitialLoading: loadingData,
    refetch: refetchQuoteDetails,
  } = useGetQuoteRequestDetails({
    shipmentId: id,
    options: {
      enabled: !!id,
      refetchOnMount: false,
    },
  });

  const { custom_longfield_01 } = data?.organization || {};

  useEffect(() => {
    refetchQuoteDetails();
  }, [state.shipmentId, state.isupdateRequest]); // eslint-disable-line react-hooks/exhaustive-deps

  function updateShipment(state: any, payload: any) {
    return {
      ...state,
      shipment: payload.shipment,
    };
  }

  function updateRequest(state: any, payload: { isupdateRequest: boolean }) {
    return {
      ...state,
      isupdateRequest: payload.isupdateRequest,
    };
  }

  return (
    <div className="provider-shipment-quotes">
      <FormProvider {...methods}>
        <QuotationHeader data={data} loadingData={loadingData} fetchShipment={fetchShipment} />
        <div className={`quotation-view-container ${!custom_longfield_01 ? "single-column" : ""}`}>
          <div className="main-content">
            <QuotesTable />
            <Comments />
          </div>
          {custom_longfield_01 && (
            <div className="sidebar-content">
              <CustomLongfield customLongfield={custom_longfield_01} />
            </div>
          )}
        </div>
      </FormProvider>
      <QuotationDetailDrawer />
    </div>
  );
};

export default ShipmentQuotesV2;
